/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespFollowSearchBanner_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespNullSearchResults_viewer$ref: FragmentReference;
export type SbRespNullSearchResults_viewer = {|
  +isShopByRoomEnabled: ?boolean,
  +isSbRespFollowSearchBannerEnabled: ?boolean,
  +$fragmentRefs: SbRespFollowSearchBanner_viewer$ref,
  +$refType: SbRespNullSearchResults_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespNullSearchResults_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isShopByRoomEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SHOP_BY_ROOM",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSbRespFollowSearchBannerEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c27cd4421e2ca3c1fdff4552e58864e0';
module.exports = node;
